import { render, staticRenderFns } from "./PageFormDialog.vue?vue&type=template&id=8179a372"
import script from "./PageFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFormDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PageFormDialog.vue?vue&type=style&index=0&id=8179a372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports